/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(["jquery"], function(jQuery) {
    "use strict";

    var topics = {};

    /* eslint new-cap: 0 */
    function getTopic(id) {
        var callbacks,
        topic = id && topics[ id ];

        if ( !topic ) {
            callbacks = jQuery.Callbacks();
            topic = {
                    publish: callbacks.fire,
                    subscribe: callbacks.add,
                    unsubscribe: callbacks.remove
            };
            if ( id ) {
                topics[ id ] = topic;
            }
        }
        return topic;
    }

    return {
        fireEvent: function(event, data) {
            var topic = getTopic(event);
            topic.publish.apply(topic, arguments);
          
            var alltopics = getTopic("*");
            alltopics.publish.apply(alltopics, arguments);
        },

        addListener: function(event, callback) {
            getTopic(event).subscribe(callback);
        },
	addMultipleListeners: function(events, callback){
      		events.forEach(e => { 
        	this.addListener(e, callback);
      		});
    	}, 
        
        removeListener: function(event, callback) {
            getTopic(event).unsubscribe(callback);
        },
        
        createCallbackHandler: function(topic, scope, fn, args){
        	var handler = function(evt, response){
				if(!args){ args = [] }
				args.push(evt);
				args.push(response);
				fn.apply(scope, args);
				
				this.removeListener(topic, callback);
			};
			var callback = handler.bind(this);
			this.addListener(topic, callback);
        }
    };
});
